import React, { useState, useEffect } from 'react';
import { ethers } from 'ethers';
import './ClaimTokens.css';
import { abi, contractAddress } from './contractABI.js';

const ClaimTokens = () => {
    const [account, setAccount] = useState('');
    const [name, setName] = useState('');
    const [country, setCountry] = useState('');
    const [countryCode, setCountryCode] = useState('');
    const [mobile, setMobile] = useState('');
    const [email, setEmail] = useState('');
    const [amount, setAmount] = useState(0);
    const [file, setFile] = useState(null);
    const [provider, setProvider] = useState(null);
    const [signer, setSigner] = useState(null);
    const [contract, setContract] = useState(null);
    const [isClaiming, setIsClaiming] = useState(false);

    // Function to fetch and load blockchain data
    const loadBlockchainData = async (userAddress) => {
        try {
            // console.log("Fetching data for address:", userAddress);
            const provider = new ethers.BrowserProvider(window.ethereum);
            const signer = await provider.getSigner();
            const contractInstance = new ethers.Contract(contractAddress, abi, signer);
    
            setProvider(provider);
            setSigner(signer);
            setContract(contractInstance);
    
            // Fetch user data from your API
            const response = await contractInstance.users(userAddress);
            
            // console.log("User Details:", response);
    
            if (response) {
                const [name, country, countryCode, mobile, email, claimableAmount] = response;
                
                // Set all values to state
                setName(name || '');
                setCountry(country || '');
                setCountryCode(countryCode || '');
                setMobile(mobile || '');
                setEmail(email || '');
    
                if (claimableAmount !== null && claimableAmount !== undefined) {
                    setAmount(ethers.formatEther(claimableAmount));  // Convert from Wei to Ether
                } else {
                    setAmount(0);
                }
            } else {
                console.error('Response is invalid');
            }
        } catch (error) {
            console.error('Error loading blockchain data:', error);
        }
    };

    // Connect wallet logic
    const handleConnectWallet = async () => {
        if (window.ethereum) {
            try {
                const provider = new ethers.BrowserProvider(window.ethereum);
                const accounts = await provider.send('eth_requestAccounts', []);
                const userAddress = accounts[0];
                setAccount(userAddress);  // Update account state

                // Load data after wallet is connected
                loadBlockchainData(userAddress);
            } catch (error) {
                console.error(error);
                alert('Failed to connect wallet');
            }
        } else {
            alert('MetaMask is not installed. Please install it to connect your wallet.');
        }
    };

    // Fetch data on component mount if the user is already connected
    useEffect(() => {
        if (account) {
            loadBlockchainData(account);
        }
    }, [account]);  // Re-render component when account is updated

    // Handle claim tokens with loading state
    const handleClaim = async () => {
        setIsClaiming(true);
        try {
            const tx = await contract.claim(name, country, countryCode, mobile, email);
            await tx.wait();
            alert('Tokens claimed successfully!');
        } catch (error) {
            console.error(error);
            alert('Failed to claim tokens');
        } finally {
            setIsClaiming(false);
        }
    };

    const handleFileChange = (e) => setFile(e.target.files[0]);

   

    return (
        <div className="form-container">
            <div className="logo">
                <img src="/logo.png" alt="DefiWorld" />
                <button id="btn" onClick={handleConnectWallet}>
                    {account ? 'Connected' : 'Connect'}
                </button>
            </div>
            {account && <p>Connected Wallet: {account}</p>}
            <i><h2 className="form-title">User Details</h2></i>
            <form>
                <div className="form-group">
                    <label htmlFor="fullName">Name</label>
                    <input type="text" id="fullName" value={name} onChange={e => setName(e.target.value)} required />
                </div>

                <div className="form-group">
                    <label htmlFor="country">Country</label>
                    <input type="text" id="country" value={country} onChange={e => setCountry(e.target.value)} required />
                </div>

                <div className="form-group">
                    <label htmlFor="countryCode">Country Code</label>
                    <input type="text" id="countryCode" value={countryCode} onChange={e => setCountryCode(e.target.value)} required />
                </div>

                <div className="form-group">
                    <label htmlFor="contactNumber">Contact Number</label>
                    <input type="tel" id="contactNumber" value={mobile} onChange={e => setMobile(e.target.value)} required />
                </div>

                <div className="form-group">
                    <label htmlFor="email">Email ID</label>
                    <input type="email" id="email" value={email} onChange={e => setEmail(e.target.value)} required />
                </div>

                <div className="form-group">
                    <label htmlFor="claimableAmount">Claimable Amount (Tokens)</label>
                    <input type="text" id="claimableAmount" value={amount} readOnly />
                </div>

                <div className="checkbox-div">
                    <input type="checkbox" id="terms" required />
                    <a href="/">Terms and Conditions</a>
                </div>

                <button type="button" onClick={handleClaim} disabled={isClaiming}>
                    {isClaiming ? 'Processing...' : 'Claim'}
                </button>
            </form>

            <hr />
        </div>
    );
};

export default ClaimTokens;
